export type RoutePermission = 'admin' | 'impersonate';

export const ROUTE_PERMISSIONS: Record<string, RoutePermission> = {
    campaigns: 'admin',
    offers: 'admin',
    segments: 'admin',
    impersonation: 'impersonate',
};

export const NAVIGATION_ORDER: string[] = ['campaigns', 'offers', 'segments', 'impersonation'];

/**
 * Checks whether the given URL segment is accessible with the provided permissions.
 * Only the first path segment is evaluated (e.g. '/campaigns/123' -> 'campaigns').
 */
export function canAccessRoute(url: string, isAdmin: boolean, hasImpersonate: boolean): boolean {
    const segment = url.split('/').filter(Boolean)[0] ?? '';

    const permission = ROUTE_PERMISSIONS[segment];

    if (!permission) {
        return true;
    }

    if (permission === 'admin') {
        return isAdmin;
    }

    return hasImpersonate;
}

/**
 * Returns the first route in NAVIGATION_ORDER that is accessible with the provided permissions.
 * Returns null when no route is accessible.
 */
export function getFirstAccessibleRoute(isAdmin: boolean, hasImpersonate: boolean): string | null {
    for (const route of NAVIGATION_ORDER) {
        if (canAccessRoute(route, isAdmin, hasImpersonate)) {
            return route;
        }
    }

    return null;
}
